import { NgModule } from '@angular/core';
import { InfiniteScrollComponent } from './infinite-scroll.component';

@NgModule({
    declarations: [
        InfiniteScrollComponent
    ],
    imports: [],
    exports: [
        InfiniteScrollComponent
    ]
})
export class NcInfiniteScrollModule { }